(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["byw-product-choice-guide"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-size-tool]').forEach((tool) => {
    const buttons = [...tool.querySelectorAll('[data-size]')];
    const name = tool.querySelector('[data-size-name]');
    const note = tool.querySelector('[data-size-note]');
    buttons.forEach((button) => button.addEventListener('click', () => {
      buttons.forEach((item) => item.setAttribute('aria-pressed', 'false'));
      button.setAttribute('aria-pressed', 'true');
      tool.style.setProperty('--frame-w', `${button.dataset.w}%`);
      tool.style.setProperty('--frame-h', `${button.dataset.h}%`);
      name.textContent = button.dataset.size;
      note.textContent = button.dataset.note;
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
